import React from 'react'
import "./CSS/Team.css";


function Team() {
    return (
        <div>
            <div className="tm-container">
                <div className="section-title">
                    <h1>Our Team</h1>
                </div>
                <div className="row">
                    <div className="column">
                        <div className="team-1">
                            <div className="team-img">

                            </div>
                            <div className="team-content">
                                <h2>Kunal kakati</h2>
                                <h3>Student</h3>
                                <p>Currently doing Bachelor's of Computer Application (BCA) at Tihu college</p>
                                <h4>Kunalkakati2003@gmail.com</h4>
                                <div className="team-social">
                                    <a className="social-tw" target="_blank" rel="noopener noreferrer" href="https://twitter.com/KUNALKAKATI4"><i className="fab fa-twitter"></i></a>
                                    <a className="social-fb" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/kunal.kakati.1/"><i className="fab fa-facebook-f"></i></a>
                                    <a className="social-li" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/kunal-kakati-ba24301b2/"><i className="fab fa-linkedin-in"></i></a>
                                    <a className="social-in" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/knl__1209/"><i className="fab fa-instagram"></i></a>
                                    <a className="social-yt" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/kunal-kakati-ba24301b2/"><i className="fab fa-youtube"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="team-1">
                            <div className="team-img">
                                {/* <img src={Tina} alt="Team" /> */}
                            </div>
                            <div className="team-content">
                                <h2>Tina Mani Haloi</h2>
                                <h3>Student</h3>
                                <p>Currently doing Bachelor's of Computer Application (BCA) at Tihu college</p>
                                <h4>Tina@example.com</h4>
                                <div className="team-social">
                                    <a className="social-tw" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/tina.kashyap.986227" ><i className="fab fa-twitter"></i></a>
                                    <a className="social-fb" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/tina.kashyap.986227" ><i className="fab fa-facebook-f"></i></a>
                                    <a className="social-li" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/tinakashyap97/" ><i className="fab fa-linkedin-in"></i></a>
                                    <a className="social-in" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/tinakashyap97/" ><i className="fab fa-instagram"></i></a>
                                    <a className="social-yt" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/tinakashyap97/" ><i className="fab fa-youtube"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="team-1">
                            <div className="team-img">
                                {/* <img src={Ritu} alt="Team" /> */}
                            </div>
                            <div className="team-content">
                                <h2>Rituparna Kalita</h2>
                                <h3>Student</h3>
                                <p>Currently doing Bachelor's of Computer Application (BCA) at Tihu college</p>
                                <h4>Rituparna@example.com</h4>
                                <div className="team-social">
                                    <a className="social-tw" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/riki.kalita.1088"><i className="fab fa-twitter"></i></a>
                                    <a className="social-fb" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/riki.kalita.1088"><i className="fab fa-facebook-f"></i></a>
                                    <a className="social-li" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/riki.kalita.1088"><i className="fab fa-linkedin-in"></i></a>
                                    <a className="social-in" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/r_i_c_k_y.k_a_l_i_t_a.1088/"><i className="fab fa-instagram"></i></a>
                                    <a className="social-yt" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/riki.kalita.1088"><i className="fab fa-youtube"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Team